// extracted by mini-css-extract-plugin
module.exports =  {"danger":"qxlACx17MHfPhRnc_UhF","warning":"Tzb9uyYVGVPr_Mt_iXgq","success":"cEcgVI6pcgl8MKct3Vwl","disabled":"JUVCSebzNecfl57NGLlV","normal":"jffYZXJys9vNQJP3gJhE"};